var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5642 25.3191C32.8799 25.4053 34.1917 25.0995 35.3336 24.4402L37.3335 27.9042C35.5065 28.9591 33.4077 29.4485 31.3026 29.3105C29.1974 29.1725 27.1805 28.4135 25.5068 27.1292C23.8331 25.845 22.5778 24.0933 21.8997 22.0956C21.2216 20.0979 21.1511 17.944 21.6971 15.9063L25.5608 16.9415C25.2196 18.2151 25.2636 19.5613 25.6874 20.8098C26.1113 22.0583 26.8958 23.1532 27.9419 23.9558C28.9879 24.7585 30.2485 25.2329 31.5642 25.3191Z",
    fill: "#117BC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2522 12.5922C28.3535 12.9988 27.5563 13.5997 26.918 14.3517C26.2797 15.1036 25.8161 15.9887 25.5608 16.9415L21.6971 15.9063C22.1056 14.3819 22.8473 12.9663 23.8686 11.7631C24.8899 10.56 26.1655 9.59852 27.6033 8.94795L29.2522 12.5922Z",
    fill: "#01AAE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7739 15.3332C37.3362 14.575 36.7534 13.9105 36.0588 13.3775C35.3643 12.8446 34.5715 12.4537 33.7259 12.2271C32.8802 12.0005 31.9982 11.9427 31.1303 12.057C30.2623 12.1713 29.4253 12.4554 28.6671 12.8931L26.6671 9.4291C27.8802 8.72872 29.2194 8.27412 30.6082 8.09127C31.997 7.90842 33.4082 8.0009 34.7612 8.36342C36.1142 8.72594 37.3826 9.35141 38.4939 10.2041C39.6052 11.0568 40.5377 12.1201 41.238 13.3331L37.7739 15.3332Z",
    fill: "#0ED6E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.667 18.6664C38.667 17.4962 38.359 16.3466 37.7739 15.3332L41.238 13.3331C42.1742 14.9546 42.667 16.794 42.667 18.6664C42.667 20.5387 42.1741 22.3781 41.2379 23.9996L37.7738 21.9997C38.3589 20.9863 38.667 19.8367 38.667 18.6664Z",
    fill: "#0092C0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.667 42.6667C52.667 41.5621 51.7716 40.6667 50.667 40.6667C49.5624 40.6667 48.667 41.5621 48.667 42.6667V46H45.3337C44.2291 46 43.3337 46.8954 43.3337 48C43.3337 49.1046 44.2291 50 45.3337 50H48.667V53.3333C48.667 54.4379 49.5624 55.3333 50.667 55.3333C51.7716 55.3333 52.667 54.4379 52.667 53.3333V50H56.0003C57.1049 50 58.0003 49.1046 58.0003 48C58.0003 46.8954 57.1049 46 56.0003 46H52.667V42.6667Z",
    fill: "#0092C0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 36C36.0795 36 39.9615 37.6818 43.014 40.5697L46.3517 38.2423C42.5623 34.3641 37.5267 32 32.0002 32C28.9188 32 25.99 32.735 23.3448 34.0576L25.1649 37.6341C27.2911 36.5765 29.6119 36 32.0002 36Z",
    fill: "#0ED6E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0127 52C16.1745 45.3551 20.1227 40.142 25.1649 37.6341L23.3448 34.0576C16.9155 37.2721 12.1612 43.958 10.9619 52H15.0127Z",
    fill: "#0092C0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3336 55.9997C11.8608 55.9997 10.653 54.8019 10.7968 53.3362C10.8409 52.8868 10.896 52.4415 10.9619 52H15.0127L34.667 51.9997V55.9997H13.3336Z",
    fill: "#117BC7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.667 52V56L34.667 55.9997V51.9997L42.667 52Z",
    fill: "#01AAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAccount);
export default __webpack_public_path__ + "static/media/AddAccount.47e37a337b59b02863336e94eb92bc77.svg";
export { ForwardRef as ReactComponent };